import { useState } from "react";
import { FaMoneyBillWave, FaPlug } from "react-icons/fa";
import ServiceCommissions from "./ServiceCommissions";
import ApiConnections from "./ApiConnections";

const MyServices = () => {
    const [activeTab, setActiveTab] = useState("connections");

    const renderContent = () => {
        switch (activeTab) {
            case "commissions":
                return <ServiceCommissions />;
            case "connections":
                return <ApiConnections />;
            default:
                return null;
        }
    };

    return (
        <div className="p-6 font-cairo bg-light min-h-screen">
            {/* التابات */}
            <div className="flex items-center justify-between mb-6 border-b border-gray-200">
                <div className="flex gap-4">
                    <button
                        onClick={() => setActiveTab("connections")}
                        className={`flex items-center gap-2 px-4 py-2 font-semibold rounded-t-lg transition ${activeTab === "connections"
                            ? "text-main1 border-b-2 border-main1"
                            : "text-gray-500 hover:text-main1"
                            }`}
                    >
                        <FaPlug /> اتصالات API
                    </button>
                    <button
                        onClick={() => setActiveTab("commissions")}
                        className={`flex items-center gap-2 px-4 py-2 font-semibold rounded-t-lg transition ${activeTab === "commissions"
                            ? "text-main1 border-b-2 border-main1"
                            : "text-gray-500 hover:text-main1"
                            }`}
                    >
                        <FaMoneyBillWave /> عمولات الخدمات
                    </button>
                </div>
            </div>

            {/* محتوى التاب */}
            {renderContent()}
        </div>
    );
};


export default MyServices;
